// extracted by mini-css-extract-plugin
export default {"modalContainer":"Vu","fadeRight":"Wu","fadeUp":"Xu","topShelf":"Yu","newFlavorBadge":"Zu","transparentText":"av","cancelButton":"bv","invisibleLink":"cv","closeIcon":"ev","linkContainer":"fv","hed":"gv","image":"hv"};
    if(module.hot) {
      // 1715188229829
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  